import {
  AuthenticationService,
  ConfigurationService,
  JWTToken,
  MessageService
} from '@philips-internal/oswald-ui-core/lib/services';
import {applicationContext, Establishment, Information} from '@philips-internal/oswald-ui-foundation/lib/context';
import TokenConstants from '../constants/TokenConstants';
import UserContext from '../utils/user-context';
import {availableModulesMapper, ParametersModule} from './available-modules-mapper';
import {getFoundationDataContext} from './bootstrap-foundation';
import {ApplicationModulesIds} from './module-registry/application-modules';

interface EstablishmentProps {
  companyName: string;
  establishmentId: number;
}
interface UserInformationProps {
  name: string;
  userId: string;
  userPhoto: string;
  username: string;
}

interface InformationBody {
  body: InformationMaper;
}

interface InformationMaper {
  currentEstablishment: EstablishmentProps;
  twsParameters: ParametersModule[];
  userInformation: UserInformationProps;
  userPhoto: string;
}

// Public modules
const defaultModules = {
  'dashboard': { cdFunction: 'dashboard', name: 'patient.home.tab.home', parameters: new Map([]) },
  'profile': { cdFunction: 'profile', name: 'patient.profile', parameters: new Map([]) },
  'tasks': { cdFunction: 'tasks', name: 'tws.patient.tasks', parameters: new Map([]) }
};
let twsDefaultModules = [ defaultModules.dashboard, defaultModules.profile, defaultModules.tasks ] as ParametersModule[];

function informationMapper(data: InformationBody): Information {

  const {twsParameters: twsUserAvailableModules = [], currentEstablishment, userInformation} = data.body;
  const token = AuthenticationService.getJWTToken() as JWTToken;
  const patientId: number = token.claims[TokenConstants.PATIENT_ID] as number;
  const showProfileModule = !(patientId == 0 || patientId == null);

  if (showProfileModule) {
    const hasProfileAlready = twsDefaultModules.some(item => item.cdFunction === ApplicationModulesIds.PROFILE);
    !hasProfileAlready && twsDefaultModules.push(defaultModules.profile as ParametersModule);
  } else {
    twsDefaultModules = twsDefaultModules.filter(item => item.cdFunction !== ApplicationModulesIds.PROFILE);
  }

  // Applies the modules released by default.
  twsUserAvailableModules.unshift(...twsDefaultModules);
  UserContext.twsUserAvailableModules = twsUserAvailableModules;

  const establishmentsAvailables = [{
    id: String(currentEstablishment.establishmentId),
    tradingName: currentEstablishment.companyName
  }] as unknown as Establishment[];

  const informationData = {
    establishment: {
      available: establishmentsAvailables,
      current: {
        id: String(currentEstablishment.establishmentId),
        locale: 'undefined',
        name: currentEstablishment.companyName,
        tradingName: currentEstablishment.companyName,
      },
    },
    module: {
      available: availableModulesMapper([], twsUserAvailableModules)
    },
    profile: {
      available: [],
      current: {
        id: 1,
        name: 'undefined',
      },
    },
    sector: {
      available: [],
      current: {
        id: 0,
        name: '',
      },
    },
    user: {
      id: userInformation.userId,
      image: userInformation.userPhoto,
      language: 'undefined',
      locale: 'undefined',
      name: userInformation.name,
      username: MessageService.translate('patient.account.holder'),
    },
  }

  const foundationContext = getFoundationDataContext();
  foundationContext.set({applicationInformationData: informationData});

  return informationData;
}

function setupAuthentication(): void {

  ConfigurationService.setEndpointMappers({
    // @ts-ignore
    information: informationMapper,
  });

  AuthenticationService.listenLogout(() => {
    applicationContext.clearNavigationStack();
    applicationContext.closeModules();
  });
}

export {
  setupAuthentication,
};
